import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, ElementRef, inject, viewChild } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { DealerContextSyncService } from '@ph-core/services/auth/dealer-context-sync.service';
import { PhButtonComponent } from '@ph-shared/components/ph-button/ph-button.component';

@Component({
  selector: 'ph-dealer-context-block',
  templateUrl: './dealer-context-block.component.html',
  styleUrls: ['./dealer-context-block.component.scss'],
  imports: [PhButtonComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-blocking]': 'isBlocking()',
  },
})
export class DealerContextBlockComponent {
  private document = inject(DOCUMENT);
  private dealerContextSync = inject(DealerContextSyncService);
  private panel = viewChild<ElementRef<HTMLElement>>('panel');

  readonly blockedDealer = this.dealerContextSync.blockedDealer;
  readonly isBlocking = computed(() => this.blockedDealer() !== null);

  constructor() {
    effect(() => {
      const panel = this.panel();
      if (this.blockedDealer() && panel) {
        panel.nativeElement.focus();
      }
    });
  }

  reload(): void {
    this.document.defaultView?.location.reload();
  }
}
